export const vulvaBuilderCatalog = {
  monspubis: {
    title: "Pubes",
    zIndex: 1,
    variants: {
      1: {
        image: "/monspubis/layer/style-1.svg",
        highlight: "/monspubis/highlight/style-1.svg",
        thumbnail: "/monspubis/thumbnail/style-1.svg",
        title: "Style 1",
      },
      2: {
        image: "/monspubis/layer/style-2.svg",
        highlight: "/monspubis/highlight/style-2.svg",
        thumbnail: "/monspubis/thumbnail/style-2.svg",
        title: "Style 2",
      },
      3: {
        image: "/monspubis/layer/style-3.svg",
        highlight: "/monspubis/highlight/style-3.svg",
        thumbnail: "/monspubis/thumbnail/style-3.svg",
        title: "Style 3",
      },
      4: {
        image: "/monspubis/layer/style-4.svg",
        highlight: "/monspubis/highlight/style-4.svg",
        thumbnail: "/monspubis/thumbnail/style-4.svg",
        title: "Style 4",
      },
      5: {
        image: "/monspubis/layer/style-5.svg",
        highlight: "/monspubis/highlight/style-5.svg",
        thumbnail: "/monspubis/thumbnail/style-5.svg",
        title: "Style 5",
      },
      6: {
        image: "/monspubis/layer/style-6.svg",
        highlight: "/monspubis/highlight/style-6.svg",
        thumbnail: "/monspubis/thumbnail/style-6.svg",
        title: "Style 6",
      },
      7: {
        image: "/monspubis/layer/style-7.svg",
        highlight: "/monspubis/highlight/style-7.svg",
        thumbnail: "/monspubis/thumbnail/style-7.svg",
        title: "Style 7",
      },
      8: {
        image: "/monspubis/layer/style-8.svg",
        highlight: "/monspubis/highlight/style-8.svg",
        thumbnail: "/monspubis/thumbnail/style-8.svg",
        title: "Style 8",
      },
      9: {
        image: "/monspubis/layer/style-9.svg",
        highlight: "/monspubis/highlight/style-9.svg",
        thumbnail: "/monspubis/thumbnail/style-9.svg",
        title: "Style 9",
      },
      10: {
        image: "/monspubis/layer/style-10.svg",
        highlight: "/monspubis/highlight/style-10.svg",
        thumbnail: "/monspubis/thumbnail/style-10.svg",
        title: "Style 10",
      },
    },
  },
  outerLabia: {
    title: "Outer Labia",
    zIndex: 3,
    variants: {
      1: {
        image: "/outer-labia/layer/style-1.svg",
        highlight: "/outer-labia/highlight/style-1.svg",
        thumbnail: "/outer-labia/thumbnail/style-1.svg",
        title: "Style 1",
      },
      2: {
        image: "/outer-labia/layer/style-2.svg",
        highlight: "/outer-labia/highlight/style-2.svg",
        thumbnail: "/outer-labia/thumbnail/style-2.svg",
        title: "Style 2",
      },
      3: {
        image: "/outer-labia/layer/style-3.svg",
        highlight: "/outer-labia/highlight/style-3.svg",
        thumbnail: "/outer-labia/thumbnail/style-3.svg",
        title: "Style 3",
      },
      4: {
        image: "/outer-labia/layer/style-4.svg",
        highlight: "/outer-labia/highlight/style-4.svg",
        thumbnail: "/outer-labia/thumbnail/style-4.svg",
        title: "Style 4",
      },
      5: {
        image: "/outer-labia/layer/style-5.svg",
        highlight: "/outer-labia/highlight/style-5.svg",
        thumbnail: "/outer-labia/thumbnail/style-5.svg",
        title: "Style 5",
      },
      6: {
        image: "/outer-labia/layer/style-6.svg",
        highlight: "/outer-labia/highlight/style-6.svg",
        thumbnail: "/outer-labia/thumbnail/style-6.svg",
        title: "Style 6",
      },
      7: {
        image: "/outer-labia/layer/style-7.svg",
        highlight: "/outer-labia/highlight/style-7.svg",
        thumbnail: "/outer-labia/thumbnail/style-7.svg",
        title: "Style 7",
      },
      8: {
        image: "/outer-labia/layer/style-8.svg",
        highlight: "/outer-labia/highlight/style-8.svg",
        thumbnail: "/outer-labia/thumbnail/style-8.svg",
        title: "Style 8",
      },
      9: {
        image: "/outer-labia/layer/style-9.svg",
        highlight: "/outer-labia/highlight/style-9.svg",
        thumbnail: "/outer-labia/thumbnail/style-9.svg",
        title: "Style 9",
      },
      10: {
        image: "/outer-labia/layer/style-10.svg",
        highlight: "/outer-labia/highlight/style-10.svg",
        thumbnail: "/outer-labia/thumbnail/style-10.svg",
        title: "Style 10",
      },
      11: {
        image: "/outer-labia/layer/style-11.svg",
        highlight: "/outer-labia/highlight/style-11.svg",
        thumbnail: "/outer-labia/thumbnail/style-11.svg",
        title: "Style 11",
      },
    },
  },
  innerLabia: {
    title: "Inner Labia",
    zIndex: 4,
    variants: {
      1: {
        image: "/inner-labia/layer/style-1.svg",
        highlight: "/inner-labia/highlight/style-1.svg",
        thumbnail: "/inner-labia/thumbnail/style-1.svg",
        title: "Style 1",
      },
      2: {
        image: "/inner-labia/layer/style-2.svg",
        highlight: "/inner-labia/highlight/style-2.svg",
        thumbnail: "/inner-labia/thumbnail/style-2.svg",
        title: "Style 2",
      },
      3: {
        image: "/inner-labia/layer/style-3.svg",
        highlight: "/inner-labia/highlight/style-3.svg",
        thumbnail: "/inner-labia/thumbnail/style-3.svg",
        title: "Style 3",
      },
      4: {
        image: "/inner-labia/layer/style-4.svg",
        highlight: "/inner-labia/highlight/style-4.svg",
        thumbnail: "/inner-labia/thumbnail/style-4.svg",
        title: "Style 4",
      },
      5: {
        image: "/inner-labia/layer/style-5.svg",
        highlight: "/inner-labia/highlight/style-5.svg",
        thumbnail: "/inner-labia/thumbnail/style-5.svg",
        title: "Style 5",
      },
      6: {
        image: "/inner-labia/layer/style-6.svg",
        highlight: "/inner-labia/highlight/style-6.svg",
        thumbnail: "/inner-labia/thumbnail/style-6.svg",
        title: "Style 6",
      },
      7: {
        image: "/inner-labia/layer/style-7.svg",
        highlight: "/inner-labia/highlight/style-7.svg",
        thumbnail: "/inner-labia/thumbnail/style-7.svg",
        title: "Style 7",
      },
      8: {
        image: "/inner-labia/layer/style-8.svg",
        highlight: "/inner-labia/highlight/style-8.svg",
        thumbnail: "/inner-labia/thumbnail/style-8.svg",
        title: "Style 8",
      },
      9: {
        image: "/inner-labia/layer/style-9.svg",
        highlight: "/inner-labia/highlight/style-9.svg",
        thumbnail: "/inner-labia/thumbnail/style-9.svg",
        title: "Style 9",
      },
      10: {
        image: "/inner-labia/layer/style-10.svg",
        highlight: "/inner-labia/highlight/style-10.svg",
        thumbnail: "/inner-labia/thumbnail/style-10.svg",
        title: "Style 10",
      },
      11: {
        image: "/inner-labia/layer/style-11.svg",
        highlight: "/inner-labia/highlight/style-11.svg",
        thumbnail: "/inner-labia/thumbnail/style-11.svg",
        title: "Style 11",
      },
      12: {
        image: "/inner-labia/layer/style-12.svg",
        highlight: "/inner-labia/highlight/style-12.svg",
        thumbnail: "/inner-labia/thumbnail/style-12.svg",
        title: "Style 12",
      },
    },
  },
  urethra: {
    title: "Urethra",
    zIndex: 5,
    variants: {
      1: {
        image: "/urethra/layer/style-1.svg",
        highlight: "/urethra/highlight/style-1.svg",
        thumbnail: "/urethra/thumbnail/style-1.svg",
        title: "Style 1",
      },
    },
  },
  clitoris: {
    title: "Clitoris",
    zIndex: 6,
    variants: {
      1: {
        image: "/clitoris/layer/style-1.svg",
        highlight: "/clitoris/highlight/style-1.svg",
        thumbnail: "/clitoris/thumbnail/style-1.svg",
        title: "Style 1",
      },
      2: {
        image: "/clitoris/layer/style-2.svg",
        highlight: "/clitoris/highlight/style-2.svg",
        thumbnail: "/clitoris/thumbnail/style-2.svg",
        title: "Style 2",
      },
      3: {
        image: "/clitoris/layer/style-3.svg",
        highlight: "/clitoris/highlight/style-3.svg",
        thumbnail: "/clitoris/thumbnail/style-3.svg",
        title: "Style 3",
      },
      4: {
        image: "/clitoris/layer/style-4.svg",
        highlight: "/clitoris/highlight/style-4.svg",
        thumbnail: "/clitoris/thumbnail/style-4.svg",
        title: "Style 4",
      },
      5: {
        image: "/clitoris/layer/style-5.svg",
        highlight: "/clitoris/highlight/style-5.svg",
        thumbnail: "/clitoris/thumbnail/style-5.svg",
        title: "Style 5",
      },
      6: {
        image: "/clitoris/layer/style-6.svg",
        highlight: "/clitoris/highlight/style-6.svg",
        thumbnail: "/clitoris/thumbnail/style-6.svg",
        title: "Style 6",
      },
      7: {
        image: "/clitoris/layer/style-7.svg",
        highlight: "/clitoris/highlight/style-7.svg",
        thumbnail: "/clitoris/thumbnail/style-7.svg",
        title: "Style 7",
      },
    },
  },
  clitoralHoods: {
    title: "Clitoral Hoods",
    zIndex: 7,
    variants: {
      1: {
        image: "/clitoral-hoods/layer/style-1.svg",
        highlight: "/clitoral-hoods/highlight/style-1.svg",
        thumbnail: "/clitoral-hoods/thumbnail/style-1.svg",
        title: "Style 1",
      },
      2: {
        image: "/clitoral-hoods/layer/style-2.svg",
        highlight: "/clitoral-hoods/highlight/style-2.svg",
        thumbnail: "/clitoral-hoods/thumbnail/style-2.svg",
        title: "Style 2",
      },
      3: {
        image: "/clitoral-hoods/layer/style-3.svg",
        highlight: "/clitoral-hoods/highlight/style-3.svg",
        thumbnail: "/clitoral-hoods/thumbnail/style-3.svg",
        title: "Style 3",
      },
    },
  },
  piercings: {
    title: "Piercings",
    zIndex: 8,
    variants: {
      1: {
        image: "/piercings/layer/style-1.svg",
        highlight: "/piercings/highlight/style-1.svg",
        thumbnail: "/piercings/thumbnail/style-1.svg",
        title: "Style 1",
      },
      2: {
        image: "/piercings/layer/style-2.svg",
        highlight: "/piercings/highlight/style-2.svg",
        thumbnail: "/piercings/thumbnail/style-2.svg",
        title: "Style 2",
      },
      3: {
        image: "/piercings/layer/style-3.svg",
        highlight: "/piercings/highlight/style-3.svg",
        thumbnail: "/piercings/thumbnail/style-3.svg",
        title: "Style 3",
      },
      4: {
        image: "/piercings/layer/style-4.svg",
        highlight: "/piercings/highlight/style-4.svg",
        thumbnail: "/piercings/thumbnail/style-4.svg",
        title: "Style 4",
      },
    },
  },
  // backgrounds: {
  //   title: "Backgrounds",
  //   zIndex: 0,
  //   variants: {
  //     1: {
  //       image: "/backgrounds/layer/style-1.svg",
  //       thumbnail: "/backgrounds/thumbnail/style-1.svg",
  //       title: "Style 1",
  //     },
  //     2: {
  //       image: "/backgrounds/layer/style-2.svg",
  //       thumbnail: "/backgrounds/thumbnail/style-2.svg",
  //       title: "Style 2",
  //     },
  //     3: {
  //       image: "/backgrounds/layer/style-3.svg",
  //       thumbnail: "/backgrounds/thumbnail/style-3.svg",
  //       title: "Style 3",
  //     },
  //     4: {
  //       image: "/backgrounds/layer/style-4.svg",
  //       thumbnail: "/backgrounds/thumbnail/style-4.svg",
  //       title: "Style 4",
  //     },
  //   },
  // },
  vagina: {
    title: "Vagina",
    zIndex: 9,
    variants: {
      1: {
        image: "/vagina/layer/style-1.svg",
        highlight: "/vagina/highlight/style-1.svg",
        thumbnail: "/vagina/thumbnail/style-1.svg",
        title: "Style 1",
      },
    },
  },
  anus: {
    title: "Anus",
    zIndex: 0,
    variants: {
      1: {
        image: "/anus/layer/style-1.svg",
        highlight: "/anus/highlight/style-1.svg",
        thumbnail: "/anus/thumbnail/style-1.svg",
        title: "Style 1",
      },
    },
  },
}
